import React from 'react';
import ReactDOM from 'react-dom';

import 'babel-polyfill';

import '../node_modules/normalize.css/normalize.css';
import '../node_modules/react-dates/lib/css/_datepicker.css';

import {SentryHelper} from '../src/helpers/sentry.helper';
import Root from './containers/Root/Root.container';
import configureStore from './store/config.store';
import {Inject} from './providers/inject';
import initProviders from './providers/initProviders';

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__ || {};  //eslint-disable-line no-underscore-dangle

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__; //eslint-disable-line no-underscore-dangle

SentryHelper.initialize(preloadedState.release);

const store = configureStore(preloadedState.store);
// Loading restaurant metadata at the first page load

initProviders(store, preloadedState)
  .then((providers) => {
    ReactDOM.render(
      (<Inject providers={providers}>
      <Root
        store={store}
        history={history}
      />
      </Inject>),
      document.getElementById('restaurant')
    );
  });



// WEBPACK FOOTER //
// ./index.js